import React from 'react';
import {
  Button,
  CircularProgress,
  Alert,
  Box,
} from '@mui/material';
import { CreditCard } from '@mui/icons-material';
import { useStripeCheckout } from '../../../hooks/useStripeCheckout';

interface StripeCheckoutButtonProps {
  planId: string;
  planName: string;
  amount: number; // in cents
  onError?: (error: string) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
}

export const StripeCheckoutButton: React.FC<StripeCheckoutButtonProps> = ({
  planId,
  planName,
  amount,
  onError,
  variant = 'contained',
  size = 'medium',
  fullWidth = false,
  disabled = false,
}) => {
  const { createCheckoutSession, loading, error, clearError } = useStripeCheckout();

  const handleCheckout = async () => {
    clearError();

    const success = await createCheckoutSession(planId, planName, amount);

    if (success) {
      window.location.href = success.url;
    } else {
      onError?.(error || 'Checkout failed');
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled || loading}
        onClick={handleCheckout}
        startIcon={loading ? <CircularProgress size={16} /> : <CreditCard />}
      >
        {loading ? 'Creating checkout session...' : `Subscribe to ${planName}`}
      </Button>
    </Box>
  );
};
